import React, { useState, useEffect } from 'react';
import '../App.css';
import { Navigate, useNavigate } from 'react-router-dom';
import logo from '../assets/logo1.png';
import user from '../assets/user_white.png';
import MyStorage from './util/storage'

const Header = ({ toggleNav }) => {
  var navigate = useNavigate()

  if (!MyStorage.isLogin()) {
    console.log('logged out');
    return <Navigate to='/login' replace/>;
  }

  return (
    <div className='header' style={{height:'10vh', backgroundColor:'#3a8a2d'}}>
      <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-start', marginLeft: 10 }}>
        <img src={logo} style={{ width: 170, height: 70 }} />
        <div style={{ marginTop:10, display: 'flex', flex: 1,  justifyContent: 'flex-end'}}>
          <img
             onClick={()=>{
               console.log('click');
               navigate('/admin/profile')
             }}
             src={user} 
             style={{ width: 50, height: 50, marginRight: 10 }}
             className='icon-btn' />
        </div>
      </div>
    </div>
  )
}

export default Header;
